<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >
    <div v-if="pages">
      <b-modal
          id="modal-delete"
          cancelTitle="Cancel"
          centered
          ok-title="Delete"
          title="Delete Page"
          @ok="deletePage"
      >
        <span>Are You Sure ?</span>
      </b-modal>
      <!-- Table Container Card -->
      <b-card
          class="mb-0"
      >
        <b-row>

          <b-col class="mb-1" cols="12" md="12">
            <h1>Pages</h1>
          </b-col>


          <b-col cols="12" md="3">
            <b-form-group label="Search">
              <debouncer :placeHolder="`search by`" @setValue="getsearchValue"></debouncer>
            </b-form-group>
          </b-col>
          <b-col class="d-flex flex-column -start  mb-1 mb-md-0"
                 cols="12" md="3"
          >
            <b-form-group label="Count">
              <v-select
                  v-model="perPage"
                  :clearable="false"
                  :options="perPageOptions"
                  class="per-page-selector  "
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
            ref="refUserListTable"
            :fields="myTableColumns"
            :items="pages"
            bordered
            class="position-relative"
            empty-text="Nothing found!"
            primary-key="id"
            responsive
            show-empty
            striped
        >
          <template #cell(edit)="data">
            <b-link :to="`/apps/dynamic-pages/update/${data.item.id}`" class="cursor-pointer">
              <feather-icon class="text-primary" icon="EyeIcon" size="20"/>
            </b-link>
          </template>

          <template #cell(delete)="data">
            <span v-b-modal.modal-delete class="cursor-pointer" @click="setSelectedPage(data.item)">
              <feather-icon class="text-danger" icon="TrashIcon" size="20"/>
            </span>
          </template>
          <template #cell(view)="data">
            <a :href="`${Helper.externalLinkBaseurl}p/${data.item.seoUrl}`" class="cursor-pointer" target="_blank">
              <feather-icon class="text-primary" icon="ExternalLinkIcon" size="20"/>
            </a>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <!-- Pagination -->
            <b-col
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
                cols="12"
                sm="6"
            >
              <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="totalCount"
                  class="mb-0 mt-1 mt-sm-0"
                  first-number
                  last-number
                  next-class="next-item"
                  prev-class="prev-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>


  </b-overlay>
</template>

<script>

import { BCard, BCol, BFormGroup, BLink, BModal, BOverlay, BPagination, BRow, BTable } from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { PageDeleteRequest, PageGetListRequest } from '@/libs/Api/Page'
import Debouncer from '@/views/components/debouncer.vue'
import Helper from '@/libs/Helper'

export default {
  computed: {
    Helper() {
      return Helper
    }
  },
  title: 'dynamic pages',
  name: 'dynamic-pages',
  data() {
    return {
      overlay: false,
      pages: null,
      totalCount: null,
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {
          key: 'title',
          label: 'title'
        },
        {
          key: 'seoUrl',
          label: 'Url'
        },
        {
          key: 'edit',
          label: 'edit'
        },
        {
          key: 'delete',
          label: 'delete'
        },
        {
          key: 'view',
          label: 'view'
        },
      ],
      pageNumber: 1,
      search: '',
      selectedPage: null,
    }
  },
  async created() {
    await this.getAllPages()
  },
  watch: {
    search: function () {
      this.getAllPages()
    },
    currentPage: function () {
      this.getAllPages()
    },
    perPage: function () {
      this.getAllPages()
    }
  },
  methods: {
    getsearchValue(data) {
      this.search = data
      this.getAllPages()
    },
    setSelectedPage(item) {
      this.selectedPage = JSON.parse(JSON.stringify(item))
    },
    async getAllPages() {
      let _this = this
      _this.overlay = true

      let data = {
        pageNumber: _this.currentPage,
        count: _this.perPage,
        search: _this.search
      }

      let pageGetListRequest = new PageGetListRequest(_this)
      pageGetListRequest.setParams(data)
      await pageGetListRequest.fetch(function (content) {
        _this.overlay = false
        _this.pages = content.data.data
        _this.totalCount = content.data.totalCount
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
      })
    },
    async deletePage() {
      let _this = this
      _this.overlay = true

      let data = {
        id: _this.selectedPage.id
      }
      let pageDeleteRequest = new PageDeleteRequest(_this)
      pageDeleteRequest.setParams(data)
      await pageDeleteRequest.fetch(function (content) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            title: `Done`,
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        _this.getAllPages()
      }, function (error) {
        _this.overlay = false
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            text: error.message,
            title: `error`,
            variant: 'danger',
          },
        })
      })
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BLink,
    Debouncer,
    BPagination,
    BOverlay,
    BModal,
    BFormGroup,
    vSelect,
  },
}
</script>

<style scoped>

</style>
